"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
exports.unitsByMeasure = {
    area: {
        'acre': __1.Acre.Self,
        'acres': __1.Acre.Self,
        'are': __1.Are.Self,
        'ares': __1.Are.Self,
        'hectare': __1.Hectare.Self,
        'hectares': __1.Hectare.Self,
        'square feet': __1.SquareFoot.Self,
        'square foot': __1.SquareFoot.Self,
        'square meter': __1.SquareMeter.Self,
        'square meters': __1.SquareMeter.Self,
        'square mile': __1.SquareMile.Self,
        'square miles': __1.SquareMile.Self
    },
    density: {
        'pounds per gallon': __1.PoundsPerGallon.Self,
        'specific gravity': __1.SpecificGravity.Self
    },
    length: {
        'centimeter': __1.Centimeter.Self,
        'centimeters': __1.Centimeter.Self,
        'feet': __1.Foot.Self,
        'foot': __1.Foot.Self,
        'inch': __1.Inch.Self,
        'inches': __1.Inch.Self,
        'kilometer': __1.Kilometer.Self,
        'kilometers': __1.Kilometer.Self,
        'meter': __1.Meter.Self,
        'meters': __1.Meter.Self,
        'mile': __1.Mile.Self,
        'miles': __1.Mile.Self,
        'rod': __1.Rod.Self,
        'rods': __1.Rod.Self
    },
    massandweight: {
        'cwt': __1.CentrumPound.Self,
        'gram': __1.Gram.Self,
        'grams': __1.Gram.Self,
        'kg': __1.Kilogram.Self,
        'kilogram': __1.Kilogram.Self,
        'kilograms': __1.Kilogram.Self,
        'long ton': __1.LongTon.Self,
        'long tons': __1.LongTon.Self,
        'metric ton': __1.MetricTon.Self,
        'metric tons': __1.MetricTon.Self,
        'milligram': __1.Milligram.Self,
        'milligrams': __1.Milligram.Self,
        'ounce': __1.Ounce.Self,
        'ounces': __1.Ounce.Self,
        'pound': __1.Pound.Self,
        'pounds': __1.Pound.Self,
        'short ton': __1.ShortTon.Self,
        'short tons': __1.ShortTon.Self
    },
    power: {
        'btu': __1.Btu.Self,
        'btus': __1.Btu.Self,
        'btu/hr': __1.Btu.Self,
        'horsepower': __1.Horsepower.Self,
        'hp': __1.Horsepower.Self,
        'kilowatt': __1.Kilowatt.Self,
        'kilowatts': __1.Kilowatt.Self,
        'kw': __1.Kilowatt.Self,
        'w': __1.Watt.Self,
        'watt': __1.Watt.Self,
        'watts': __1.Watt.Self
    },
    pressure: {
        'atmosphere': __1.Atmosphere.Self,
        'atmospheres': __1.Atmosphere.Self,
        'bar': __1.Bar.Self,
        'bars': __1.Bar.Self,
        'columns of water': __1.ColumnOfWater.Self,
        'inches of mercury': __1.InchOfMercury.Self,
        'kilopascal': __1.Kilopascal.Self,
        'kilopascals': __1.Kilopascal.Self,
        'mmhg': __1.MillimeterOfMercury.Self,
        'millimeters of mercury': __1.MillimeterOfMercury.Self,
        'pascal': __1.Pascal.Self,
        'pascals': __1.Pascal.Self,
        'pounds per square inch': __1.PoundsPerSquareInch.Self
    },
    time: {
        'day': __1.Day.Self,
        'days': __1.Day.Self,
        'hour': __1.Hour.Self,
        'hours': __1.Hour.Self,
        'minute': __1.Minute.Self,
        'minutes': __1.Minute.Self,
        'second': __1.Second.Self,
        'seconds': __1.Second.Self,
        'year': __1.Year.Self,
        'years': __1.Year.Self
    },
    volume: {
        'acre inch': __1.AcreInch.Self,
        'acre inches': __1.AcreInch.Self,
        'centiliter': __1.Centiliter.Self,
        'centiliters': __1.Centiliter.Self,
        'cubic feet': __1.CubicFoot.Self,
        'cubic foot': __1.CubicFoot.Self,
        'cubic inch': __1.CubicInch.Self,
        'cubic inches': __1.CubicInch.Self,
        'cubic meter': __1.CubicMeter.Self,
        'cubic meters': __1.CubicMeter.Self,
        'cubic yard': __1.CubicYard.Self,
        'cubic yards': __1.CubicYard.Self,
        'fluid ounce': __1.FluidOunce.Self,
        'fluid ounces': __1.FluidOunce.Self,
        'gallon': __1.Gallon.Self,
        'gallons': __1.Gallon.Self,
        'liter': __1.Liter.Self,
        'liters': __1.Liter.Self,
        'milliliter': __1.Milliliter.Self,
        'milliliters': __1.Milliliter.Self,
        'pint': __1.Pint.Self,
        'pints': __1.Pint.Self,
        'quart': __1.Quart.Self,
        'quarts': __1.Quart.Self
    }
};
